<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
        <path
            d="M28 10V34M28 34L19 25M28 34L37 25"
            stroke="var(--custom-color-main)"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10 34V38C10 42.4183 13.5817 46 18 46H38C42.4183 46 46 42.4183 46 38V34"
            stroke="var(--custom-color-gray)"
            stroke-width="3"
            stroke-linecap="round"
        />
    </svg>
</template>
